/**
 * Formatiert einen Timestamp als deutsches Datum mit Uhrzeit.
 * z.B. "18.03.2026 um 14:05"
 */
export function formatDateDE(ts) {
  try {
    if (!ts) return '—';
    const d = new Date(Number(ts));
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    const hh = String(d.getHours()).padStart(2, '0');
    const min = String(d.getMinutes()).padStart(2, '0');
    return `${dd}.${mm}.${yyyy} um ${hh}:${min} Uhr`;
  } catch {
    return '—';
  }
}

/**
 * Formatiert einen Timestamp für die Telemetrie-Tabelle.
 * z.B. "18.03.2026 - 14:05"
 */
export function formatTelemetryTimestamp(ts) {
  try {
    if (!ts) return '—';
    const d = new Date(Number(ts));
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    const hh = String(d.getHours()).padStart(2, '0');
    const min = String(d.getMinutes()).padStart(2, '0');
    return `${dd}.${mm}.${yyyy} - ${hh}:${min}`;
  } catch {
    return '—';
  }
}
